import React from 'react';
import { EU_COUNTRIES, countryToCode, getCountryName } from '../data/euCountries';

/**
 * Šalies pasirinkimas – ES šalių sąrašas.
 * value: ISO kodas (LT, DE, ...) arba pavadinimas (suderinamumui su senaisiais duomenimis).
 * onChange: (code: string) => void – perduoda ISO kodą.
 */
function CountrySelect({ value, onChange, language = 'lt', disabled, className, id, required, placeholder }) {
  const code = value && value.length === 2 ? value : countryToCode(value || '');

  const handleChange = (e) => {
    const newCode = e.target.value || '';
    onChange(newCode);
  };

  return (
    <select
      id={id}
      value={code}
      onChange={handleChange}
      disabled={disabled}
      className={className}
      required={required}
    >
      {placeholder && (
        <option value="">{placeholder}</option>
      )}
      {EU_COUNTRIES.map((c) => (
        <option key={c.code} value={c.code}>
          {getCountryName(c.code, language)}
        </option>
      ))}
    </select>
  );
}

export default CountrySelect;
export { countryToCode, getCountryName };
